/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { injectIntl, intlShape } from 'react-intl';
import { format } from 'date-fns';
import { Link } from 'react-router';
import PropsPanel from 'loracoms/PropsPanel';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';

const kFormatter = (x) => {
  if (x) {
    return <span>{format(x, 'YYYY-MM-DD HH:mm:ss')}</span>;
  }
  return <span>--</span>;
};

const propTypes = {
  intl: intlShape.isRequired,
  status: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  gatewayStatus: PropTypes.object.isRequired,
};

class Status extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: props.status,
      gatewayStatus: props.gatewayStatus,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.gateway.status');
  }

  componentDidMount() {
    this.handleStatusData(this.state.gatewayStatus);
  }

  componentWillReceiveProps({ gatewayStatus, status }) {
    if (!_.isEqual(gatewayStatus, this.props.gatewayStatus)) {
      this.setState({ gatewayStatus });
      this.handleStatusData(gatewayStatus);
    }
    if (status !== this.props.status) {
      this.setState({ status });
    }
  }

  handleStatusData(gateway = {}) {
    const { liveness = [] } = gateway;
    const allNodes = liveness.length;
    const workMapNodes = (_.filter(liveness, l => l.type === '功图')).length;
    const pressNodes = (_.filter(liveness, l => l.type === '压力')).length;
    const electriNodes = (_.filter(liveness, l => l.type === '电参')).length;
    const tempNodes = (_.filter(liveness, l => l.type === '温度')).length;

    this.setState({ allNodes, workMapNodes, pressNodes, electriNodes, tempNodes });
  }

  render() {
    const { id } = this.props;
    const {
      status,
      gatewayStatus,
      allNodes,
      workMapNodes,
      pressNodes,
      electriNodes,
      tempNodes,
    } = this.state;
    return (
      <div>
        <PropsPanel
          readOnly
          title={this.intlMsg.msg('basic.header')}
          data={gatewayStatus}
          status={status}
          properties={[{
            id: 'ver',
            name: this.intlMsg.msg('ver'),
          }, {
            id: 'now',
            name: this.intlMsg.msg('now'),
            formatter: kFormatter,
          }, {
            id: 'since',
            name: this.intlMsg.msg('since'),
            formatter: kFormatter,
          }, {
            id: 'lastsync',
            name: this.intlMsg.msg('lastsync'),
            formatter: kFormatter,
          },
          ]}
        />
        <PropsPanel
          readOnly
          title={this.intlMsg.msg('counters.header')}
          data={gatewayStatus.counters || {}}
          status={status}
          properties={[{
            id: 'attfail',
            name: this.intlMsg.msg('attfail'),
          }, {
            id: 'attok',
            name: this.intlMsg.msg('attok'),
          }, {
            id: 'overrun',
            name: this.intlMsg.msg('overrun'),
          },
          ]}
        />
        <PropsPanel
          readOnly
          title={this.intlMsg.msg('statis.header')}
          data={{
            allNodes: <Link to={`/network/tdm/gateway/${id}/allnodes`}>{allNodes}</Link>,
            workMapNodes: <Link to={`/network/tdm/gateway/${id}/workmapnodes`}>{workMapNodes}</Link>,
            pressNodes: <Link to={`/network/tdm/gateway/${id}/pressnodes`}>{pressNodes}</Link>,
            electriNodes: <Link to={`/network/tdm/gateway/${id}/electrinodes`}>{electriNodes}</Link>,
            tempNodes: <Link to={`/network/tdm/gateway/${id}/tempnodes`}>{tempNodes}</Link>,
          }}
          status={status}
          properties={[{
            id: 'allNodes',
            name: this.intlMsg.msg('node.all'),
          }, {
            id: 'workMapNodes',
            name: this.intlMsg.msg('node.work.map'),
          }, {
            id: 'pressNodes',
            name: this.intlMsg.msg('node.press'),
          }, {
            id: 'electriNodes',
            name: this.intlMsg.msg('node.electri.param'),
          }, {
            id: 'tempNodes',
            name: this.intlMsg.msg('node.temp'),
          }]}
        />
      </div>
    );
  }
}

Status.propTypes = propTypes;

export default injectIntl(CSSModules(Status, styles, { allowMultiple: true }));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/GatewayStatus/Status.jsx